import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as AccountingCoinsIcon } from '../../assets/images/svg/accounting-coins.svg';
import themeColors from '../../assets/styles/themeColors';

const AccountingCoinsIconStyled = styled.div`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  border-radius: 100%;
  background-color: ${themeColors.colorBackgroundPrimaryDark};
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    circle {
      fill: ${({ cc }) => cc || themeColors.colorBackgroundPrimaryDark};
      stroke: ${({ cs }) => cs || 'none'};
    }

    path {
      fill: ${({ fillColor }) => fillColor || themeColors.colorTextPrimary};
      stroke: ${({ strokeColor }) => strokeColor || 'none'};
    }
  }
`;

const AccountingCoins = (props) => (
  <AccountingCoinsIconStyled {...props}>
    <AccountingCoinsIcon />
  </AccountingCoinsIconStyled>
);

AccountingCoins.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  circleColor: PropTypes.string,
  circleStroke: PropTypes.string,
  fillColor: PropTypes.string,
  strokeColor: PropTypes.string,
};

AccountingCoins.defaultProps = {
  w: '62px',
  h: '62px',
};

export default AccountingCoins;
